export default "__VITE_ASSET__Dp7MAZI3__"